// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2rbco","productName":"Table_productName__5FFUx"};